module.exports = __webpack_public_path__ + "img/reward-2.3056278d.webp";